import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisEdition/styles.scss';export default {
  "projectStrategicAxisEdition": "_projectStrategicAxisEdition_ftdit_1",
  "operator": "_operator_ftdit_11",
  "cell": "_cell_ftdit_15",
  "weight": "_weight_ftdit_21",
  "icon": "_icon_ftdit_27",
  "listRoot": "_listRoot_ftdit_31",
  "input": "_input_ftdit_39",
  "consistencyValueSelection": "_consistencyValueSelection_ftdit_56",
  "inputText": "_inputText_ftdit_60",
  "openedInput": "_openedInput_ftdit_67",
  "iconOpen": "_iconOpen_ftdit_73",
  "iconClose": "_iconClose_ftdit_82",
  "list": "_list_ftdit_31",
  "role": "_role_ftdit_97"
};